import { WSPillProps } from "@wingspanhq/fe-component-library";
import {
  BackgroundCheck,
  BackgroundCheckStatus
} from "@wingspanhq/wingspan-api-sdk";

import {
  ContextItem,
  RequirementContextType,
  RequirementStatusViewProps,
  RequirementTableItemData
} from "../../../../types";

export const getBackgroundCheckRequirementStatus = (
  requirement: RequirementTableItemData,
  contextItem: ContextItem,
  backgroundCheck: BackgroundCheck | undefined,
  contextType: RequirementContextType
): RequirementStatusViewProps => {
  let pill: WSPillProps;
  let secondaryText: string | undefined;

  if (backgroundCheck?.status === BackgroundCheckStatus.SUCCESS) {
    pill = {
      theme: "success",
      text: "Complete",
      icon: true
    };
  } else if (
    backgroundCheck?.status === BackgroundCheckStatus.NEW ||
    backgroundCheck?.status === BackgroundCheckStatus.PENDING
  ) {
    if (contextType === RequirementContextType.Payee) {
      pill = {
        theme: "neutral",
        text: "Awaiting contractor",
        icon: "time"
      };
      secondaryText = "Awaiting contractor completion";
    } else {
      if (backgroundCheck?.status === BackgroundCheckStatus.PENDING) {
        pill = {
          theme: "warning",
          text: "Action required",
          icon: true
        };
        secondaryText = "Awaiting your completion";
      } else {
        pill = {
          theme: "neutral",
          text: "Processing",
          icon: "time"
        };
      }
    }
  } else if (backgroundCheck?.status === BackgroundCheckStatus.PROCESSING) {
    pill = {
      theme: "neutral",
      text: "Processing",
      icon: "time"
    };
    secondaryText = "Awaiting results";
  } else {
    pill = {
      theme: "error",
      text: "Failed",
      icon: true
    };
    secondaryText = backgroundCheck?.statusReason ?? undefined;
  }

  return {
    pill,
    secondaryText
  };
};
